"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageEditorHelpTabs = exports.AuthFlow = exports.ModuleFederationRemotes = exports.UserScope = exports.RankStyleType = exports.FocusElementType = exports.CustomContentDialogState = exports.CustomContentType = exports.CreateCustomComponentAction = exports.CreateCustomComponent = exports.QuiltWrapperWidgetCategory = exports.WidgetCategory = exports.HeadingLevel = exports.ModalSize = exports.WidgetPageContext = exports.LoadingTheme = exports.LoadingSpacing = exports.LoadingSize = void 0;
var LoadingSize;
(function (LoadingSize) {
    LoadingSize["SM"] = "sm";
    LoadingSize["LG"] = "lg";
})(LoadingSize || (exports.LoadingSize = LoadingSize = {}));
var LoadingSpacing;
(function (LoadingSpacing) {
    LoadingSpacing["SM"] = "sm";
    LoadingSpacing["MD"] = "md";
    LoadingSpacing["LG"] = "lg";
    LoadingSpacing["XL"] = "xl";
    LoadingSpacing["NONE"] = "none";
})(LoadingSpacing || (exports.LoadingSpacing = LoadingSpacing = {}));
var LoadingTheme;
(function (LoadingTheme) {
    LoadingTheme["DARK"] = "dark";
    LoadingTheme["LIGHT"] = "light";
})(LoadingTheme || (exports.LoadingTheme = LoadingTheme = {}));
var WidgetPageContext;
(function (WidgetPageContext) {
    WidgetPageContext["NODE"] = "node";
    WidgetPageContext["USER"] = "user";
})(WidgetPageContext || (exports.WidgetPageContext = WidgetPageContext = {}));
var ModalSize;
(function (ModalSize) {
    ModalSize["SM"] = "sm";
    ModalSize["LG"] = "lg";
    ModalSize["XL"] = "xl";
})(ModalSize || (exports.ModalSize = ModalSize = {}));
var HeadingLevel;
(function (HeadingLevel) {
    HeadingLevel["H1"] = "h1";
    HeadingLevel["H2"] = "h2";
    HeadingLevel["H3"] = "h3";
    HeadingLevel["H4"] = "h4";
    HeadingLevel["H5"] = "h5";
    HeadingLevel["H6"] = "h6";
})(HeadingLevel || (exports.HeadingLevel = HeadingLevel = {}));
var WidgetCategory;
(function (WidgetCategory) {
    WidgetCategory["CONTENT"] = "content";
    WidgetCategory["PEOPLE"] = "people";
    WidgetCategory["PLACES"] = "places";
    WidgetCategory["CUSTOM_HTML_CONTENT"] = "customHtmlContent";
    WidgetCategory["CUSTOM_CONTENT"] = "customContent";
})(WidgetCategory || (exports.WidgetCategory = WidgetCategory = {}));
var QuiltWrapperWidgetCategory;
(function (QuiltWrapperWidgetCategory) {
    QuiltWrapperWidgetCategory["CUSTOM_HTML_CONTENT"] = "customHtmlContent";
    QuiltWrapperWidgetCategory["CUSTOM_CONTENT"] = "customContent";
    QuiltWrapperWidgetCategory["COMMON"] = "common";
})(QuiltWrapperWidgetCategory || (exports.QuiltWrapperWidgetCategory = QuiltWrapperWidgetCategory = {}));
var CreateCustomComponent;
(function (CreateCustomComponent) {
    CreateCustomComponent["CONTENT"] = "content";
    CreateCustomComponent["WIDGET_NAME"] = "widgetName";
    CreateCustomComponent["WIDGET_DESCRIPTION"] = "widgetDescription";
    CreateCustomComponent["COMPONENT_ID_PREFIX"] = "custom.widget.";
})(CreateCustomComponent || (exports.CreateCustomComponent = CreateCustomComponent = {}));
var CreateCustomComponentAction;
(function (CreateCustomComponentAction) {
    CreateCustomComponentAction["CANCEL"] = "cancel";
    CreateCustomComponentAction["SUBMIT"] = "submit";
})(CreateCustomComponentAction || (exports.CreateCustomComponentAction = CreateCustomComponentAction = {}));
var CustomContentType;
(function (CustomContentType) {
    CustomContentType["STATIC"] = "static";
    CustomContentType["DYNAMIC"] = "dynamic";
})(CustomContentType || (exports.CustomContentType = CustomContentType = {}));
var CustomContentDialogState;
(function (CustomContentDialogState) {
    CustomContentDialogState[CustomContentDialogState["NO_SHOW"] = 0] = "NO_SHOW";
    CustomContentDialogState[CustomContentDialogState["SELECTOR"] = 1] = "SELECTOR";
    CustomContentDialogState[CustomContentDialogState["STATIC"] = 2] = "STATIC";
    CustomContentDialogState[CustomContentDialogState["DYNAMIC"] = 3] = "DYNAMIC";
})(CustomContentDialogState || (exports.CustomContentDialogState = CustomContentDialogState = {}));
var FocusElementType;
(function (FocusElementType) {
    FocusElementType["NODE_DETAIL"] = "nodeDetail";
    FocusElementType["NODE_EXPAND"] = "nodeExpand";
})(FocusElementType || (exports.FocusElementType = FocusElementType = {}));
var RankStyleType;
(function (RankStyleType) {
    RankStyleType["TEXT"] = "text";
    RankStyleType["OUTLINE"] = "outline";
    RankStyleType["FILLED"] = "filled";
})(RankStyleType || (exports.RankStyleType = RankStyleType = {}));
/**
 * Used to determine the type of the widget
 */
var UserScope;
(function (UserScope) {
    UserScope["OTHER"] = "other";
    UserScope["SELF"] = "self";
})(UserScope || (exports.UserScope = UserScope = {}));
var ModuleFederationRemotes;
(function (ModuleFederationRemotes) {
    ModuleFederationRemotes["SLOT_1"] = "slot1";
    ModuleFederationRemotes["SLOT_2"] = "slot2";
    ModuleFederationRemotes["SLOT_3"] = "slot3";
    ModuleFederationRemotes["MAIN"] = "main";
})(ModuleFederationRemotes || (exports.ModuleFederationRemotes = ModuleFederationRemotes = {}));
var AuthFlow;
(function (AuthFlow) {
    AuthFlow["LOGIN"] = "login";
    AuthFlow["REGISTRATION"] = "registration";
    AuthFlow["FORGOT_PASSWORD"] = "forgotPassword";
    AuthFlow["MULTI_AUTH_LOGIN"] = "multiAuthLogin";
})(AuthFlow || (exports.AuthFlow = AuthFlow = {}));
var MessageEditorHelpTabs;
(function (MessageEditorHelpTabs) {
    MessageEditorHelpTabs["SHORTCUTS"] = "shortcuts";
    MessageEditorHelpTabs["KEYBOARD_NAVIGATION"] = "keyboardNavigation";
    MessageEditorHelpTabs["MARKDOWN_SYNTAX"] = "markdownSyntax";
})(MessageEditorHelpTabs || (exports.MessageEditorHelpTabs = MessageEditorHelpTabs = {}));
//# sourceMappingURL=enums.js.map